import React from "react";
import HeroBgAnimation from "../HeroBgAnimation";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  Img,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  ButtonGroup,
  ResumeButton,
  Span2,
} from "./HeroStyle";
import HeroImg from "../../images/kay-kang.png";
import Typewriter from "typewriter-effect";
import { Bio } from "../../data/constants";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

const Free = {
  free: "Available",
};

const HeroSection = () => {
  return (
    <div id="about">
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer>
          <HeroLeftContainer id="Left">
            <Title>
              Hi, I am <br /> {Bio.name}
            </Title>
            <TextLoop>
              My Skills
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>{Bio.description}</SubTitle>
            <ButtonGroup>
              <ResumeButton href={Bio.resume} target="display">
                <DescriptionRoundedIcon /> Check Resume
              </ResumeButton>
              <ResumeButton href={Bio.linkedin} target="display" $secondary>
                <LinkedInIcon /> LinkedIn
              </ResumeButton>
            </ButtonGroup>
            {/* // I am available */}
            <TextLoop>
              I am
              <Span2>
                <Typewriter
                  options={{
                    strings: Free.free,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span2>
            </TextLoop>
          </HeroLeftContainer>

          <HeroRightContainer id="Right">
            <Img src={HeroImg} alt="hero-image" />
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;
